'use client';

import { useState, type SyntheticEvent } from 'react';
import NextImage, { type ImageProps } from 'next/image';
import ImageSkeleton from 'components/commercetools-ui/atoms/image-skeleton';

export type LoadingImageProps = ImageProps & {
  /** Classes for the positioning wrapper the skeleton is anchored to. */
  wrapperClassName?: string;
};

/**
 * A `next/image` that shows a skeleton in its own footprint until the bytes arrive.
 */
const LoadingImage = ({ wrapperClassName = '', onLoad, onError, ...imageProps }: LoadingImageProps) => {
  const [hasSettled, setHasSettled] = useState(false);

  const settle = () => setHasSettled(true);

  return (
    <span className={`relative block ${wrapperClassName}`.trim()}>
      {!hasSettled && <ImageSkeleton />}
      <NextImage
        {...imageProps}
        onLoad={(event: SyntheticEvent<HTMLImageElement>) => {
          settle();
          onLoad?.(event);
        }}
        // A failed image settles too — otherwise a broken photo skeletons forever.
        onError={(event: SyntheticEvent<HTMLImageElement>) => {
          settle();
          onError?.(event);
        }}
      />
    </span>
  );
};

export default LoadingImage;
